module.exports = __webpack_public_path__ + "images/voted-most-popular-c6cb416409460263103896282947adb2.png";